var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-info is-fullheight"},[_c('menu-public'),_c('div',{class:_vm.currentRouteName==='/policy'?'':'hero-body'},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }